import angular from 'angular';
import SideBannersComponent from './side-banners.component';

let SideBannersModule = angular.module('shared.components.banners.sideBannersModules.sideBanners', [])
  .component('sideBanners', SideBannersComponent);

export default SideBannersModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/banners/side-banners/side-banners.js
 **/